import { render, staticRenderFns } from "./SyncGroupDatabasesDialog.vue?vue&type=template&id=68cd7a2e&"
import script from "./SyncGroupDatabasesDialog.vue?vue&type=script&lang=ts&"
export * from "./SyncGroupDatabasesDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports